"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFiocTexts = void 0;
const Literals = __importStar(require("../constants/fioc.literals"));
const types_1 = require("../types");
const fioc_helpers_1 = require("../helpers/fioc.helpers");
// This "hook" does not use react, consider moving it to helpers
const useFiocTexts = ({ days, userName, nextReviewDate, translate }) => {
    const getPoeditorKeyForExpiring = (descriptionNumber) => `${Literals.BASE_KEY}.mbModalUpdateKyc.day${days}.description${descriptionNumber}`;
    return {
        [types_1.FiocType.EXPIRED]: {
            title: translate(Literals.TITLE, { name: userName || '' }),
            cancelButton: translate(Literals.CANCEL_BUTTON),
            goToProfileButton: translate(Literals.GO_TO_PROFILE),
            contentDescription01: translate(Literals.EXPIRED_FIOC_DESCRIPTION01),
            contentDescription02: translate(Literals.EXPIRED_FIOC_DESCRIPTION02),
            contentDescription03: translate(Literals.EXPIRED_FIOC_DESCRIPTION03),
            closeButtonAltText: translate(Literals.CLOSE_BUTTON_ALT_TEXT),
        },
        [types_1.FiocType.NON_EXPIRED]: {
            title: translate(Literals.TITLE, { name: userName || '' }),
            cancelButton: translate(Literals.CANCEL_BUTTON),
            goToProfileButton: translate(Literals.GO_TO_PROFILE),
            contentDescription01: translate(getPoeditorKeyForExpiring('01'), {
                daysRemaining: (0, fioc_helpers_1.getDaysRemaining)(nextReviewDate),
                expiringDate: (0, fioc_helpers_1.getFormattedDate)(nextReviewDate),
            }),
            contentDescription02: translate(getPoeditorKeyForExpiring('02')),
            contentDescription03: translate(getPoeditorKeyForExpiring('03')),
            contentDescription04: translate(getPoeditorKeyForExpiring('04')),
            closeButtonAltText: translate(Literals.CLOSE_BUTTON_ALT_TEXT),
        },
    };
};
exports.useFiocTexts = useFiocTexts;
exports.default = exports.useFiocTexts;
//# sourceMappingURL=useFiocTexts.hook.js.map